import { render, staticRenderFns } from "./FlipMemoryGame.vue?vue&type=template&id=530d2bd6&scoped=true&"
import script from "./FlipMemoryGame.vue?vue&type=script&lang=js&"
export * from "./FlipMemoryGame.vue?vue&type=script&lang=js&"
import style0 from "./FlipMemoryGame.vue?vue&type=style&index=0&id=530d2bd6&prod&scoped=true&lang=css&"
import style1 from "./FlipMemoryGame.vue?vue&type=style&index=1&id=530d2bd6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530d2bd6",
  null
  
)

export default component.exports